import e from"./ClearRefinements.vue_vue&type=script&lang.js";import{render as t}from"./ClearRefinements.vue_vue&type=template&id=410a3aaa&lang.js";e.render=t,e.__file="src/components/ClearRefinements.vue";export default e;
//# sourceMappingURL=ClearRefinements.vue.js.map
